module.exports = __webpack_public_path__ + "img/american-express-icon.b1b64a23.png";